module.exports = __webpack_public_path__ + "img/zhanli6.e8e9b54c.jpg";